import React from "react";
import { FileText } from "react-feather";
import { ConnectorLogo } from "../../atoms/ConnectorLogo";
import { KgCollapsedNodeHover } from "../KgCollapsedNodeHover";
import { rawColors } from "../../../design-system/tokens/colors";
import {
  BiName,
  Body,
  Card,
  CornerFold,
  Footer,
  FooterContent,
  IconBox,
  ReportName,
} from "./KgReportNodeCard.styles";
import type { KgReportNodeCardProps } from "./KgReportNodeCard.types";

export const KgReportNodeCard: React.FC<KgReportNodeCardProps> = ({
  name,
  biName,
  biLogoUrl,
  collapsed = false,
  visualState = "default",
  isSelected = false,
  onClick,
}) => {
  if (collapsed) {
    return (
      <KgCollapsedNodeHover
        icon={<FileText size={16} />}
        color={rawColors.accent.pink}
        bgColor={rawColors.accent.pinkLight}
        visualState={visualState}
        title={name}
        subtitle={biName ?? "Report"}
        logoUrl={biLogoUrl}
        logoName={biName ?? name}
      />
    );
  }

  return (
    <Card
      $visualState={visualState}
      $isSelected={isSelected}
      $hasFooter={Boolean(biName || biLogoUrl)}
      onClick={onClick}
      role="group"
      tabIndex={0}
    >
      <CornerFold />
      <Body>
        <IconBox>
          <FileText size={20} color={rawColors.accent.pink} />
        </IconBox>
        <ReportName title={name}>{name}</ReportName>
      </Body>
      {(biName || biLogoUrl) && (
        <Footer>
          <FooterContent>
            {biLogoUrl && (
              <ConnectorLogo src={biLogoUrl} name={biName ?? ""} size="xxs" />
            )}
            {biName && <BiName title={biName}>{biName}</BiName>}
          </FooterContent>
        </Footer>
      )}
    </Card>
  );
};

export default KgReportNodeCard;
